import ChooseWorkspace from './ChooseWorkspace';

export default ChooseWorkspace;
